export default {
  wrapperNew: {
    margin: '0 auto',
    flex: 1,
  },
};
